import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-project-requests',
  standalone: true,
  imports: [],
  templateUrl: './project-requests.component.html',
  styleUrl: './project-requests.component.css',
})
export class ProjectRequestsComponent implements OnInit {
  projectId!: string;
  projectName: string;
  isHovering1 = false;
  isHovering2 = false;
  isHovering3 = false;
  isHovering4 = false;
  isHovering5 = false;
  isHovering6 = false;
  isHovering7 = false;
  isHovering8 = false;
  isHovering9 = false;
  isHovering10 = false;
  isHovering11 = false;
  isHovering12 = false;
  isHovering13 = false;
  isHovering14 = false;

  projectIdentifier: string;
  constructor(private router: Router, private activeRoute: ActivatedRoute) {}

  ngOnInit() {
    this.activeRoute.paramMap.subscribe((params) => {
      // NOTE: projectId matches param in routes file
      this.projectId = params.get('projectId');
    });
    this.activeRoute.queryParams.subscribe((params) => {
      this.projectIdentifier = params['projectIdentifier'];
      this.projectName = params['projectName'];
    });
  }

  navigateToTendering() {
    if (this.projectId) {
      this.router.navigate(['/requested-tendering', this.projectId], {
        queryParams: {
          projectName: this.projectName,
          projectIdentifier: this.projectIdentifier,
        },
      });
    }
  }
}
